<template>
  <FloatingPillButton variant="overlay">
    <template #start>
      <AiBackgroundSelectIcon />
    </template>
    <template #center>
      {{ I18n.t("editor.magic_background.variants.variant_a.select_template") }}
    </template>
  </FloatingPillButton>
</template>

<script setup lang="ts">
import { FloatingPillButton, AiBackgroundSelectIcon } from "prism";
import { inject, onMounted } from "vue";

const I18n = inject("I18n");
const props = defineProps<{
  hideWidget: () => void;
}>();

onMounted(() => {
  setTimeout(() => {
    props.hideWidget();
  }, 4000);
});
</script>
